import axios from "axios";
import _ from "lodash";
import { getLocalLotteryType, setLocalLotteryType } from "../utils/localStorageService";


// 六合生肖
export const getLhShengXiao = (params = {}) => {
  return axios.get('/ssc_golang/v1/lottery/animals?random='+new Date().getTime(), {
    params: {params}
  });
};

const lottery_types = {
  1: "gd_ha10",
  2: "cc_ssc",
  3: "pk10",
  4: 'lh',
  5: 'fantan',
};

const cache = {};

export const getLotteryTypes = () => {
  const url = "/ssc_golang/v1/lottery/types?random="+new Date().getTime();
  if (cache[url]) return cache[url];

  return axios.get(url).then(info => {
    if (info.result === "ok") {
      //console.log('info', info);
      info.data = info.data.map((item, index) => {
        item.top = item.lottery_name.substring(0, 2);
        item.b = item.lottery_name.substring(2);
        item.active = true;
        item.title = item.lottery_name;
        //item.path = item.url;
        if (!item.id) item.id = item.lottery_type;

        // 非外部链接
        if (!/^https?/.test(item.path) && lottery_types[item.category]) {
          // 判断类型
          const query = [
            `lottery_type=${item.lottery_type}`,
            `category_id=${item.category}`
          ];
          item.path =
            "/home/" + lottery_types[item.category] + "?" + query.join("&");
        }
        // 六合
        if (item.category === 4) {
          //item.url = `http://sc.lottos365.com/?lottery_type=${item.lottery_type}`;
        }
        return item;
      });

      cache[url] = info;
    }

    const checkData = info.data;
    const newLotteryType = getLocalLotteryType() || [];
    // 跟最新的后台数据对比，过滤出两者都有的
    const someArry = filterArray(newLotteryType, checkData);
    // 把匹配出相同的跟最新的做比较，把不同的合并到老someArry后面
    const diffArry = filterDiffArray(checkData, someArry);
    const default_info = someArry.concat(diffArry);
    setLocalLotteryType(default_info);
    return {
      ...info,
      data: default_info
    };
  });
};

// 过滤出相同元素
function filterArray(arr1, arr2) {
  let someArray = [];
  arr1.forEach(arr => {
    if (arr2.some(checkArr => _.isEqual(arr, checkArr))) {
      someArray.push(arr);
    }
  });
  // 深拷贝，并去重
  var newObj = _.cloneDeep(someArray);
  return _.uniqWith(newObj, _.isEqual);
}

function filterDiffArray(arr1, arr2) {
  let diffArray = [];
  arr1.forEach(arr => {
    if (arr2.some(checkArr => _.isEqual(arr, checkArr))) {
    } else {
      diffArray.push(arr);
    }
  });
  return diffArray;
}

// 获取子玩法列表
export const getLotteryChildData = id => {
  const url = `/ssc_golang/v1/lottery/category/${id}`+'?random='+new Date().getTime();
  if (cache[url]) return cache[url];
  return axios.get(url).then(info => {
    if (info.result === "ok") {
      info.data = info.data.map(item => {
        return {
          ...item,
          value: item.sub_category_id,
          label: item.sub_category_name
        };
      });
      cache[url] = info;
    }
    return info;
  });
};

// 获取当前玩法赔率
export const getOddsData = async ({category_id, sub_category_id, lottery_type, played_name = ''}) => {
  const params = (() => {
    const p = {
      category_id,
      sub_category_id,
      lottery_type,
      played_name
    };
    const ps = [];
    for (let i in p) ps.push(`${i}=${p[i]}`);
    return ps;
  })();
  let url = `/ssc_golang/v1/odds?${params.join("&")}`+'&random='+new Date().getTime();
  url = encodeURI(encodeURI(url,'utf-8'));
  // if (cache[url]) return cache[url];
  return axios.get(url).then(info => {
    if (info.result === "ok") cache[url] = info;
    return info;
  });
};

// 开奖历史结果查询
export const getLotteryResults = (params) => {
  return axios
    .get("/ssc_golang/v1/results?random="+new Date().getTime(), {
      params
    })
    .then(info => {
      if (info.result === "ok") info.data = info.data || [];
      return info;
    });
};

// 获取最新投注
export const getLotteryLatest = () => {
  return axios.get("/ssc_golang/v1/order/latest?random="+new Date().getTime());
};

// 最新彩种开奖结果查询
// 历史开奖结果
const res_cache = {};

export const getNewLotteryRes = async ({sub_category_id, lottery_type}) => {
  const key = `/ssc_golang/v1/lottery_${lottery_type}`;
  let info = await axios.get("/ssc_golang/v1/lottery?random="+new Date().getTime(), {
    params: {sub_category_id, lottery_type}
  });

  // 当前时间
  const now = Date.now();

  // info.data.next_info.block_time = 5;
  // info.data.next_info.remain_time = 10;

  /***
   * 如果存在上一次开奖结果
   * 并且这次请求的开奖结果和上一次开奖结果一致
   * 认定为当前次开奖结果还没同步开奖，轮询开奖结果
   * 停止条件：当前结果已经不存在，或者下一期开奖已经不存在，或者当前开奖结果和上一次的开奖结果不一致，或返回的上一次开奖和当前开奖qishu
   */
  if (
    res_cache[key] &&
    info.result === "ok" &&
    info.data &&
    info.data.latest_result &&
    info.data.next_info
  ) {
    const isNotDraw =
      res_cache[key] &&
      res_cache[key].latest_result &&
      res_cache[key].latest_result.period === info.latest_result.period;

    const isDrawing =
      info.data.latest_result.period === info.data.next_info.period ||
      !info.data.next_info.block_time ||
      info.data.next_info.remain_time <= 1;

    /*if (isNotDraw || isDrawing) info = await new Promise(resolve => {
      setTimeout(async () => {
        const info = await getNewLotteryRes(lottery_type);
        resolve(info);
      }, 3000);
    });*/

    info.data.next_info.timestamp *= 1000;
    info.data.next_info.timestamp += Date.now() - now;

    return info;
  }

  res_cache[key] = info;

  if (
    info.result === "ok" &&
    info.data &&
    info.data.latest_result &&
    info.data.next_info
  ) {
    info.data.next_info.timestamp *= 1000;
    info.data.next_info.timestamp += Date.now() - now;
  }

  return info;
};

// 投注
export const createLotteryOrder = ({
                                     category_id,
                                     sub_category_id,
                                     lottery_type,
                                     period,
                                     data,
                                     fast_bet = ''
                                   }) => {
  if (data instanceof Array) data = JSON.stringify(data);
  return axios.post("/ssc_golang/v1/order/create", {
    category_id,
    sub_category_id,
    lottery_type,
    period,
    data,
    fast_bet
  });
};

// 长龙排行榜
export const getLongQueue = lottery_type => {
  return axios.get("/ssc_golang/v1/results/longqueue?random="+new Date().getTime(), {
    params: {lottery_type}
  });
};

// 彩种规则头部
export const getRules = ({lottery_type}) => {
  return axios
    .get("/ssc_golang/v1/lottery/rule?random="+new Date().getTime(), {
      params: {
        lottery_type
      }
    })
    .then(info => {
      if (info.result === "ok") info.data = info.data || [];
      return info;
    });
};

// 最近开奖统计
export const getStatistics = lottery_type => {
  return axios.get("/ssc_golang/v1/results/statistics?random="+new Date().getTime(), {
    params: {lottery_type}
  });
};



// WEBPACK FOOTER //
// ./src/service/lottery.js